import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';
import useCount from './use-count';

export type BusCountVehicle = Pick<VehicleCycledEnergyRecord, 'vehicleType' | 'propulsion'>;

const useBusCount = (vehicles: BusCountVehicle[], propulsion: 'BEV' | 'PHEV' = 'BEV'): number => {
  return useCount({
    items: vehicles,
    predicate: (v) => v.vehicleType === 'Bus' && (v.propulsion ?? 'BEV') === propulsion,
  });
};

export default useBusCount;
